
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const BenchIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 68.3264C86.3649 67.2029 88 64.7924 88 62V55C88 51.134 84.866 48 81 48H80V23.5C80 21.567 78.433 20 76.5 20C74.567 20 73 21.567 73 23.5V24H23V23.5C23 21.567 21.433 20 19.5 20C17.567 20 16 21.567 16 23.5L16 27.5V48H15C11.134 48 8 51.134 8 55V62C8 64.7924 9.63505 67.2029 12 68.3264L12 72.5C12 74.433 13.567 76 15.5 76C17.433 76 19 74.433 19 72.5V69H77V72.5C77 74.433 78.567 76 80.5 76C82.433 76 84 74.433 84 72.5V68.3264ZM15 55H81V62H15V55ZM73 43V48H23L23 43H73ZM73 36V31H23V36H73Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 55C11.5 53.067 13.067 51.5 15 51.5H81C82.933 51.5 84.5 53.067 84.5 55V62C84.5 63.933 82.933 65.5 81 65.5H15C13.067 65.5 11.5 63.933 11.5 62L11.5 55Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M84 68.3264C86.3649 67.2029 88 64.7924 88 62V55C88 51.134 84.866 48 81 48H80V23.5C80 21.567 78.433 20 76.5 20C74.567 20 73 21.567 73 23.5V24H23V23.5C23 21.567 21.433 20 19.5 20C17.567 20 16 21.567 16 23.5L16 27.5V48H15C11.134 48 8 51.134 8 55V62C8 64.7924 9.63505 67.2029 12 68.3264L12 72.5C12 74.433 13.567 76 15.5 76C17.433 76 19 74.433 19 72.5V69H77V72.5C77 74.433 78.567 76 80.5 76C82.433 76 84 74.433 84 72.5V68.3264ZM15 55H81V62H15V55ZM73 43V48H23L23 43H73ZM73 36V31H23V36H73Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 55C11.5 53.067 13.067 51.5 15 51.5H81C82.933 51.5 84.5 53.067 84.5 55V62C84.5 63.933 82.933 65.5 81 65.5H15C13.067 65.5 11.5 63.933 11.5 62L11.5 55Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
